import objectAssign from "object-assign";
import initialState from "./initialState";
import { UPDATE_CONTACT_INFO } from "../actions/actionTypes";

export default function contactInfoReducer(
  state = initialState.contactInfo,
  action
) {
  switch (action.type) {
    case UPDATE_CONTACT_INFO:
      return objectAssign({}, state, action.contactInfo);
    default:
      return state;
  }
}
